var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadingImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81969E",
    d: "M2.5 2.5h32v28h-32z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 8,
    fill: "rgba(21, 87, 191, 0.7)",
    stroke: "#FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 29.667L30.003 27 33 29.667M30 27v6.667"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 3.5,
    stroke: "#81969E"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#81969E",
    d: "M2.373 24.779l8.01-6.716 4.755 5.035 10.007-9.905 9.372 8.634"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadingImages);
export default __webpack_public_path__ + "static/media/uploading-images.7a83d709f50081f5871600a430f1f385.svg";
export { ForwardRef as ReactComponent };